import React from 'react';

import classNames from 'classnames';

import styles from './tab.less';

export const TabSection: React.StatelessComponent = (props) => (
  <div {...props} className={classNames(styles.tabSection)} />
);

export const TabList: React.StatelessComponent = (props) => (
  <ul {...props} className={styles.tabList} />
);

export const Tab: React.StatelessComponent = (props) => (
  <li {...props} className={styles.tab} />
);

export const TabRightChild: React.StatelessComponent = (props) => (
  <div {...props} className={styles.tabRightChild} />
);

export interface TabIconProps {
  iconName: string;
}

export const TabIcon: React.StatelessComponent<TabIconProps> = ({
  iconName,
  ...props
}) => (
  <span {...props} className={classNames(styles.tabIcon)}>
    <span
      className={classNames(`icon-${iconName}`, 'icon-sm', styles.tabIconSpan)}
    />
  </span>
);

export interface TabLogoProps {
  logoUrl1x: string;
  logoUrl2x: string;
}

export const TabLogo: React.StatelessComponent<TabLogoProps> = ({
  logoUrl1x,
  logoUrl2x,
  ...props
}) => (
  <img
    src={logoUrl1x}
    srcSet={`${logoUrl1x} 1x, ${logoUrl2x} 2x`}
    width={16}
    height={16}
    alt=""
    role="presentation"
    className={styles.tabLogo}
    {...props}
  />
);

export const TabText: React.StatelessComponent = (props) => (
  <span {...props} className={styles.tabText} />
);

interface TabBaseProps {
  className?: string;
  indented?: boolean;
  selected?: boolean;
  small?: boolean;
}

export type TabLinkProps = TabBaseProps &
  React.DOMAttributes<HTMLAnchorElement>;
export type TabButtonProps = TabBaseProps &
  React.DOMAttributes<HTMLButtonElement>;

export const TabLink: React.StatelessComponent<TabLinkProps> = ({
  selected,
  indented,
  className,
  ...props
}) => (
  <a
    {...props}
    className={classNames(
      styles.tabLink,
      {
        [styles.selected]: selected,
        [styles.tabListIndent]: indented,
      },
      className,
    )}
  />
);

export const TabButton: React.StatelessComponent<TabButtonProps> = ({
  selected,
  small,
  className,
  ...props
}) => (
  <button
    {...props}
    className={classNames(
      styles.tabButton,
      {
        [styles.selected]: selected,
        [styles.small]: small,
      },
      className,
    )}
  />
);



// WEBPACK FOOTER //
// ./app/scripts/views/home/presentational/tab.tsx